import { filter } from './obj';

/**
 * 判断是否为完整http链接
 * @param url 链接地址
 */
export const isHttpUrl = (url) => /^https?:\/\/\S+\.\S+/.test(url);

/** 对象转url参数 */
export const stringify = (params) => {
  const filteredParams = filter(params);

  if (window.URLSearchParams) {
    return new URLSearchParams(filteredParams).toString();
  }

  return Object.keys(filteredParams)
    .map((key) => `${key}=${encodeURIComponent(filteredParams[key])}`)
    .join('&');
};

/** 解析url上的查询参数 */
export const parse = (queryStr) => {
  if (!queryStr) return {};

  if (window.URLSearchParams) {
    return Object.fromEntries(new URLSearchParams(queryStr));
  }

  const qstr = queryStr[0] === '?' ? queryStr.slice(1) : queryStr;

  const kvArr = qstr.split('&');
  return kvArr.reduce((p, c) => {
    const [key, value] = c.split('=');
    return { ...p, [key]: decodeURIComponent(value) };
  }, {});
};

export function getUrlParam(key) {
  const { href } = window.location;

  const queryStr = href.slice(href.indexOf('?'));

  if (window.URLSearchParams) {
    const params = new URLSearchParams(queryStr);
    return key ? params.get(key) : Object.fromEntries(params);
  }

  const params = parse(queryStr);
  return key ? params[key] : params;
}

export const download = (url, fileName) => {
  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', fileName || '');
  a.setAttribute('target', '_blank');
  a.click();
};
